import type { CheckpointDefinition, NetworkComponent } from '../types';

export type VisitStatus = 'correct' | 'already' | 'out-of-order' | 'complete';

export interface VisitResult {
  status: VisitStatus;
  checkpoint?: CheckpointDefinition;
  next?: CheckpointDefinition;
}

export class LevelProgression {
  private index = 0;
  private readonly visited = new Set<NetworkComponent>();

  constructor(private readonly checkpoints: CheckpointDefinition[]) {}

  visit(component: NetworkComponent): VisitResult {
    const checkpoint = this.checkpoints.find((item) => item.id === component);
    if (!checkpoint) return { status: 'out-of-order', next: this.next };
    if (this.visited.has(component)) return { status: 'already', checkpoint, next: this.next };
    if (this.next?.id !== component) return { status: 'out-of-order', checkpoint, next: this.next };

    this.visited.add(component);
    this.index += 1;
    return {
      status: this.index >= this.checkpoints.length ? 'complete' : 'correct',
      checkpoint,
      next: this.next,
    };
  }

  get next(): CheckpointDefinition | undefined {
    return this.checkpoints[this.index];
  }

  get correctConnections(): number {
    return this.index;
  }

  get totalConnections(): number {
    return this.checkpoints.length;
  }
}

